module.exports = __webpack_public_path__ + "img/shade_quote.9aadaf4f.svg";